module.exports = __webpack_public_path__ + "static/img/img_logo.e8272bfd.png";